const PATH = 'fe.components.organization.pagination';

const messages = {
  paginationAriaLabel: {
    key: `${PATH}.pagination_aria_label`,
    defaultValue: 'Pagination'
  },
  pageInputLabel: {
    key: `${PATH}.page_input_label`,
    defaultValue: 'Page'
  },
  inContext: {
    key: `${PATH}.in_context`,
    defaultValue: ' in {{context}}'
  },
  previousPageAriaLabel: {
    key: `${PATH}.previous_page_aria_label`,
    defaultValue: 'Previous page{{context}}'
  },
  nextPageAriaLabel: {
    key: `${PATH}.next_page_aria_label`,
    defaultValue: 'Next page{{context}}'
  },
  pageAriaLabel: {
    key: `${PATH}.page_aria_label`,
    defaultValue: 'Page {{page}} of {{total}}{{context}}'
  },
  invalidPageNumber: {
    key: `${PATH}.invalid_page_number`,
    defaultValue: 'Enter a page number from 1 to {{total}}.'
  }
};

export default messages;
